<template>
    <el-col class="grid-col">
        <el-card class="grid-card" shadow="hover">
            <div style="padding: 0 10px 10px 10px;">
                <!-- 批量删除按钮 -->
                <div><el-checkbox :label="item.id" :indeterminate="false"><br></el-checkbox></div>
                <div class="grid-card-title">
                    <div class="icon" :class="item.icon+'-black'"></div>
                    <div class="grid-name">
                        <div name="listTaskName" v-if="isFlag<1" @click="editTaskListName(item)" :title="item.name">{{item.name}}</div>
                        <el-input ref="listInputName" v-if="isFlag>0" :disabled="isFlag==1" class="grid-card-edit" type="textarea" :autosize="{minRows:1,maxRows:2}" resize="none" v-model="showTaskName" @blur="submitTaskListName(item)" @keydown.enter.native="enterEvent(item,$event)"></el-input>
                    </div>
                </div>
                <!-- 定时 -->
                <div class="grid-schdule">
                    <tabTaskSchdule ref="tabTaskSchdule" :task="item" @update="clickScheduleBtn" @open-popup="openFunctionPopup" v-if="isShowSchdule(item)"></tabTaskSchdule>
                </div>
                <!-- 路由 -->
                <div class="grid-route">
                    <!-- 来源 -->
                    <div class="grid-route-item" v-if="item.fromItem">
                        <div class="task-icon-multi" v-if="item.fromItem.icons.length>1" @click.stop="openFunctionPopup(8)">
                            <!-- 多源图标拼接 -->
                            <div class="clouds_logo clouds_logo_30" v-for="(fromItem,index) in item.fromItem.icons.slice(0, 4)" :key="index" :class="fromItem.driveType" :style="(item.fromItem.icons.length==3&&index==0)?'margin: 0 15px;':''"></div>
                            <div v-if="item.fromItem.icons.length>4&&item.fromItem.icons.length<10" class="task-icon-multi-more">{{item.fromItem.icons.length}}</div>
                            <div v-if="item.fromItem.icons.length>9" class="task-icon-multi-more">9+</div>
                        </div>
                        <!-- 多源单云盘 -->
                        <div class="task-icon clouds_logo clouds_logo_60" :class="item.fromItem.icons[0].driveType" v-else @click.stop="toSourceCatalog(item)"></div>
                        <div class="grid-route-name">
                            <span v-if="item.fromItem.icons.length>1" @click.stop="openFunctionPopup(8)" :title="getCatalog(item.fromItem.lists[0].nodes)">{{$t('language.taskList.multiClouds')}}</span>
                            <span v-else>
                                <span v-if="item.fromItem.lists[0].driveType == 'offlinesTask'" @click.stop="copyLink(item.fromItem.lists[0].name)">
                                    {{$t('language.common.copyLink')}}
                                </span>
                                <span v-else @click.stop="toSourceCatalog(item)" :title="getCatalog(item.fromItem.lists[0].nodes)">{{getNewCloudName(item.fromItem.lists[0])}}</span>
                            </span>
                        </div>
                    </div>
                    <!-- <div class="grid-route-item" v-else @click.stop="toSourceCatalog(item)">
                        <div class="task-icon clouds_logo clouds_logo_60" :class="item.fromItem.driveType"></div>
                        <div class="grid-route-name" :title="item.fromItem.nodes|getCatalog|getCatalogTitle">
                          {{item.fromItem.nodes[item.fromItem.nodes.length-1]|getItemName}} 
                        </div>
                    </div> -->
                    <div v-if="(item.type == 2 && item.options && item.options.way == '20') || (item.type == 1 && item.options && item.options.isRemove == '1')" class="sync_arrow"></div>
                    <div v-else class="double_arrow"></div>
                    <!-- 目的 -->
                    <div class="grid-route-item" v-if="item.toItem">
                        <div class="task-icon-multi" v-if="item.toItem.icons.length>1" @click.stop="openFunctionPopup(8)">
                            <!-- 多目标图标拼接 -->
                            <div class="clouds_logo clouds_logo_30" v-for="(toItem,index) in item.toItem.icons.slice(0, 4)" :key="index" :class="toItem.driveType" :style="(item.toItem.icons.length==3&&index==0)?'margin: 0 15px;':''"></div>
                            <div v-if="item.toItem.icons.length>4&&item.toItem.icons.length<10" class="task-icon-multi-more">{{item.toItem.icons.length}}</div>
                            <div v-if="item.toItem.icons.length>9" class="task-icon-multi-more">9+</div>
                        </div>
                        <!-- 多目标单云盘 -->
                        <div class="task-icon clouds_logo clouds_logo_60" :class="item.toItem.icons[0].driveType" v-else @click.stop="toAimCatalog(item)"></div>
                        <div class="grid-route-name">
                            <span v-if="item.toItem.icons.length>1" @click.stop="openFunctionPopup(8)" :title="getCatalog(item.toItem.lists[0].nodes)">{{$t('language.taskList.multiClouds')}}</span>
                            <span v-else @click.stop="toAimCatalog(item)">
                                <span v-if="item.type==6&&(item.tranferWay=='restore'||item.tranferWay=='retry-restore')&&(item.status==1||item.status==2)&&(!item.isRestoreNew)">
                                    {{$t('language.cloudBackup.original')}}
                                </span>
                                <span v-else :title="getCatalog(item.toItem.lists[0].nodes)">{{getNewCloudName(item.toItem.lists[0])}}</span>
                            </span>
                        </div>
                    </div>
                    <!-- <div class="grid-route-item" v-else @click.stop="toAimCatalog(item)">
                        <div class="task-icon clouds_logo clouds_logo_60" :class="item.toItem.driveType"></div>
                        <div class="grid-route-name" :title="item.toItem.nodes|getCatalog|getCatalogTitle">{{item.toItem.nodes[item.toItem.nodes.length-1]|getItemName}}</div>
                    </div> -->
                </div>
                <!-- 状态 -->
                <div class="grid-function" @mouseleave="changeOptionMenu(false)">
                    <div class="grid-state">
                        <!-- 显示任务状态 -->
                        <tabTaskStatus ref="tabTaskStatus" :task="item" @open-popup="openFunctionPopup"></tabTaskStatus>
                    </div>
                    <div class="grid-btns">
                        <!-- 显示任务功能 -->
                        <tabTaskOption ref="tabTaskOption" :task="item" @open-popup="openFunctionPopup" @update="clickButton"></tabTaskOption>
                    </div>
                </div>
            </div>
        </el-card>
    </el-col>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";
import taskListSingelJS from "@/js/workspace/task_list_singel.js";
//任务定时，状态和功能
import tabTaskSchdule from "@/components/common/tabs/tabs_task_list/tab_task_schdule";
import tabTaskStatus from "@/components/common/tabs/tabs_task_list/tab_task_status";
import tabTaskOption from "@/components/common/tabs/tabs_task_list/tab_task_option";
export default {
    name: "taskListFormCard",
    props: ['item', 'collapseFlage', 'index', 'tasklistData', 'detailShow', 'eidtTaskFlag'],
    data: function() {
        return {
            isOpenMenu: false,
            menuTop: 35,
            threadChange: false, //用于子组件渲染界面
            unfinishedArr: ["Cancel", "cancel", "error"],
            pathJson: [],
            taskListMenuTop: 32,
            executeFlag: true,
            buttonTxt: this.$t('language.cloudTransfer.transferNow'), //用于显示按钮上的文字
            statusTxt: '', //显示单个任务的状态文案
            iconName: null,
            transferDetailChange: false, //用于子组件渲染界面
            refreshFlag: true, //标识是否刷新界面
            switchTypeFlag: true,
            openRestoreFlag: true, //标识是否打开还原界面
            user: commonUtils.getUser(),
            isFlag: 0,//0关闭，2开启，1禁用
            showTaskName: "",
        }
    },
    components: {
        tabTaskSchdule,
        tabTaskStatus,
        tabTaskOption,
    },
    computed: {
    },
    activated() {
    },
    watch: {
        transferDetailChange() {
            this.initTask();
        },
        executeFlag() {
            this.initTask();
        },
        threadChange() {
            this.initTask();
        },
        item: {
            immediate: true,
            deep: true,
            handler(value) {
              this.initTask();
            }
        },
        tasklistData: {
            immediate: true,
            deep: true,
            handler(value) {
              this.item = value[this.index];
            }
        },
    },
    mounted() {
    },
    methods: {
        // 获取第一个路由用于hover显示
        getCatalog(nodesArr) {
            let catelog;
            if (nodesArr && nodesArr.length >= 2 &&nodesArr[0].fileId  && nodesArr[0].fileId == nodesArr[1].fileId) {
                nodesArr.splice(0, 1);
            }
            if (nodesArr) {
                let cloudItem = nodesArr[nodesArr.length - 1];
                if(cloudItem.tokenId) {
                    // 如果有云盘id，则去获取云盘名称
                    var drives = this.$store.getters.getUsersDrives;
                    for (var i=0; i<drives.length; i++) {
                        if (drives[i].id == cloudItem.tokenId) {
                            catelog = drives[i].name;
                            break;
                        }
                    }
                }else {
                    if (cloudItem.fileName) {
                        catelog = cloudItem.fileName;
                    } else if(cloudItem.filename){
                        catelog = cloudItem.filename;
                    }else{
                        catelog = cloudItem.name;
                    }
                }
                for (let i = nodesArr.length - 2; i >= 0; i--) {
                    if (catelog) {
                        if (nodesArr[i].fileName) {
                            catelog = catelog + '\\' + nodesArr[i].fileName;
                        } else if(nodesArr[i].filename){
                            catelog = catelog + '\\' + nodesArr[i].filename;
                        }else{
                            catelog = catelog + '\\' + nodesArr[i].name;
                        }
                    } else {
                        if (nodesArr[i].fileName) {
                            catelog = nodesArr[i].fileName;
                        } else if(nodesArr[i].filename){
                            catelog = nodesArr[i].filename;
                        }else{
                            catelog = nodesArr[i].name;
                        }
                    }
                }
            }
            return catelog;
        },
        // 获取源云盘或目标云盘名称，用于显示name
        getNewCloudName(item) {
            if(item.driveId) {
                // 如果有云盘id，则去获取云盘名称
                var driveName = null;
                var drives = this.$store.getters.getUsersDrives;
                for (var i=0; i<drives.length; i++) {
                    if (drives[i].id == item.driveId) {
                        driveName = drives[i].name;
                        break;
                    }
                }
                return driveName;
            }else {
                return item.name;
            }
        },
        // 链接复制功能
        copyLink(url) {
            let oInput = document.createElement('input');
            oInput.value = url;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象;
            document.execCommand("Copy"); // 执行浏览器复制命令
            this.$toast({
                text: this.$t('language.popup.cloudExploerPopup.linkCopySuccessful'),
                type: 'success',
                idValue: "rightBodyList",
            });
            oInput.remove();
        },
      //打开功能弹窗
      openFunctionPopup(type,task) {
        if(!task){
          task = this.item;
          }
            console.log(type,task)
          //打开弹窗
          this.$emit("open-function-popup",type,task);
      },
      //控制功能菜单状态
      changeOptionMenu(type) {
          this.isOpenMenu = type;
      },
      initTask() {
        //显示任务的状态
        this.iconName = this.item.iconName;
        this.statusTxt = this.item.statusTxt;
        //显示按钮的文案
        this.buttonTxt = this.item.buttonTxt;
      },
      //点击最右边按钮
      clickButton(type,task,callback) {
        console.log(type)
        if(type == 0) {
          this.$emit("pause-task",task,() => {
            callback();
          });
        }else if(type == 1) {
          this.$emit("execute-task",task,() => {
            callback();
          });
        }
      },
      isShowSchdule(item) {
        if(item.lowerType==105||(item.lowerType==102&&item.branchType=='realtime')) {
          return false;
        }else {
          return true;
        }
      },
      isNumber(val) { //判断字段是否是数字
        var regPos = /^\d+(\.\d+)?$/; //非负浮点数
        var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
        if (regPos.test(val) || regNeg.test(val)) {
          return true;
        } else {
          return false;
        }
      },
      //选择左边的云盘
      selectOption(sourceData) {
        let dom;
        let rootDir;
        let that = this;
        let driveId;
        if (sourceData.driveId) {
          driveId = sourceData.driveId;
        } else {
          driveId = sourceData.nodes[0].tokenId;
        }
        $.each(that.$parent.$parent.$parent.$parent.$children, function(i, item) {
          if (item.menuOptions) { //如果是left_banner组件
            dom = that.$parent.$parent.$parent.$parent.$children[i];
            return;
          }
        });
        let clouds = dom.clouds;
        $.each(clouds, function(i, item) {
          if (driveId == item.id) {
            dom.driveOptionSelect(i);
            return false;
          }
        });
      },
      //跳转到目标云盘的目录
      toAimCatalog(item) {
        if(item.toItem.lists.length > 1) {
          //多目标
          this.openFunctionPopup(8);
        }else {
          this.$emit("to-aim",item.toItem.lists[0],item.taskType);
        }
      },
      //跳转到源目录
      toSourceCatalog(item) {
        if(item.fromItem.lists[0].driveType == 'offlinesTask') {
            return;
        }
        if(item.fromItem.lists.length > 1) {
          //多源
          this.openFunctionPopup(8);
        }else {
          this.$emit("to-source",item.fromItem.lists[0],item.taskType);
        }
      },
      //改变任务的设定时间状态
      clickScheduleBtn(item,index) {
        taskListSingelJS.clickScheduleBtn(this,item,index);
      },
      //开启修改任务名输入框
      editTaskListName(item) {
        if(item.lowerType == 105)return;
        this.showTaskName = item.name;
        this.isFlag = 2;
        this.$nextTick(() => {
          this.$refs.listInputName.select();
        });
      },
      //关闭并还原修改任务名输入框
      cancelUpdateTaskName(item) {
        this.showTaskName = "";
        this.isFlag = 0;
      },
      enterEvent(item,event) {
        if(!event.ctrlKey) {
          event.preventDefault();
          this.submitTaskListName(item);
        }else {
          this.showTaskName += '\n';
        }
      },
      //提交任务名
      submitTaskListName(item) {
        //非正常开启不提交
        if(this.isFlag<2)return;

        var inputValue = this.showTaskName.trim();
        if(inputValue && inputValue != item.name) {
          if (inputValue.length > 200) {
            this.$toast({
              text: this.$t('language.taskList.taskNameRule'),
              type: 'fail',
              idValue: "rightBodyList"
            });
            this.cancelUpdateTaskName(item);
            return false;
          }

          //禁用输入框
          this.isFlag = 1;

          if (item.branchType == "businessTransfer") {
            this.updateBusinessTask(item);
            return;
          }

          var updateData;
          if (item.isMultiTask) {
            updateData = new taskListUtils.updateGdData(item.id, commonUtils.getUser().id, item.type, inputValue,null, null);
          } else {
            updateData = new taskListUtils.updateIdData(item.id, commonUtils.getUser().id, item.type, inputValue,null, null);
          }
          this.Utils.doTasksRequest("update", updateData).then(result => {
            if (result.status == 200) {
              //成功修改名称
              item.name = inputValue;
              this.cancelUpdateTaskName(item);
            } else {
              //未成功修改名称,退回名称
              this.cancelUpdateTaskName(item);
              this.$toast({
                text: this.$t('language.exception.' + result.reason),
                type: 'fail',
                idValue: "rightBodyList"
              });
            }
          });
        } else {
          this.cancelUpdateTaskName(item);
        }
      },
      //提交重命名的任务名
      updateBusinessTask(item) {
        var updateData = {
          n: this.showTaskName,
          id: item.id,
          ud: commonUtils.getUser().id
        }
        this.Utils.doBusinessTransferRequest("update", updateData).then(data => {
          item.name = this.showTaskName;
          this.cancelUpdateTaskName(item);
        }).catch(err => {
          if (err.reason) {
            err = that.$t('language.exception.' + err.reason)
          }
          this.cancelUpdateTaskName(item);
          this.$toast({
            text: err,
            type: 'fail',
            idValue: "rightBodyList"
          });
        });
        
      },
      listTargetFiles(task, callback) {
        var that = this;
        let listData = new cloudExploerUtils.filelistData(task.toItem.fileId, commonUtils.getUser().id, task.toItem
          .driveId, null, null, null);
        that.Utils.doFilesRequest("list", listData, {
          timeout: 600000
        }).then(res => {
          callback(res);
        });

      },
      getRealTimeStatus() {
        let item = this.item;
        let that = this;
        let t;
        var getData;
        if (item.groupId) {
          getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, null, groupId);
        } else {
          getData = new taskListUtils.getTasks(commonUtils.getUser().id, item.type, item.id, null);
        }
        this.Utils.doRealtimeSyncRequest("get", getData).then(result => {
          if (result.data && result.data.status == 'Run') {
            that.item.t = setTimeout(() => {
              that.getRealTimeStatus();
            }, 300000);
          } else if (result.data && result.data.status == 'TimeStop') {
            clearTimeout(that.item.t);
            that.tasklistData[that.index] = result.data;
            that.$forceUpdate();
          }
        });
      },
      //如果没有path，则封装Path数据
      encapsulationPath(sourceAimData, pathData) {
        let that = this;
        let driveId;
        that.pathJson = [];
        if (sourceAimData.driveId) {
          driveId = sourceAimData.driveId;
        } else {
          driveId = sourceAimData.nodes[0].tokenId;
        }
        if (!pathData) {
          for (let i = sourceAimData.nodes.length - 1; i >= 0; i--) {
            let name;
            if (sourceAimData.nodes[i].fileName) {
              name = sourceAimData.nodes[i].fileName;
            } else {
              name = sourceAimData.nodes[i].filename;
            }
            that.pathJson.push({
              id: sourceAimData.nodes[i].fileId,
              name: name,
              driveId: driveId
            });
            let JsonList = Object.assign([], that.pathJson);
            that.$store.commit("setPathJson", {
              folderId: sourceAimData.nodes[i].fileId + driveId,
              json: JsonList
            });
          }
        }
      },
      //获取多个源目录，返回目录数组
      getMultiSourceCatalog(itemData) {
        let catalogArr = [];
        let catalogName;
        if (itemData.branchType == 'share') {
          //有路径则显示路径，没有就显示名字
          if (itemData.fromItem.lists[0].sharePath) {
            catalogName = commonUtils.getCatalog(JSON.parse(itemData.fromItem.lists[0].sharePath));
          } else {
            catalogName = itemData.fromItem.lists[0].name;
          }
        } else {
          if (itemData.fromItem.lists[0]) {
            catalogName = commonUtils.getCatalog(itemData.fromItem.lists[0].nodes);
          }
        }
        var shareUrl;
        if (itemData.fromItem.lists[0]) {
          shareUrl = itemData.fromItem.lists[0].shareUrl
        }
        let catalog = {
          catalog: catalogName,
          fromItem: itemData.fromItem.lists[0],
          isShare: itemData.branchType == 'share' ? true : false,
          shareUrl: shareUrl
        }
        catalogArr.push(catalog);
        $.each(itemData.sources, function(i, item) {
          let catalogMultName;
          if (itemData.branchType == 'share') {
            if (item.fromItem.sharePath) {
              catalogMultName = commonUtils.getCatalog(JSON.parse(item.fromItem.sharePath));
            } else {
              catalogMultName = item.fromItem.name;
            }
          } else {
            if (item.fromItem) {
              catalogMultName = commonUtils.getCatalog(item.fromItem.nodes);
            }
          }
          let catalogMult = {
            catalog: catalogMultName,
            fromItem: item.fromItem
          }
          catalogArr.push(catalogMult);
        });
        return catalogArr;
      },
      //点击分享链接
      toSharelicLink(item) {
        if (item.sharePath) {
          this.$store.commit("setSharePath", JSON.parse(item.sharePath));
        }
        let link = item.shareUrl;
        window.open(link);
      },
      //执行任务
      executeTask(item, index) {
        this.$emit("execute-task",item,this.index);
      },
    },
    filters: {
      ellipsis(value) {
        if (!value) return '';
        if (value.length > 39) {
          return value.slice(0, 39) + '...';
        }
        return value;
      },
    }

  }
</script>

<style scoped>
.grid-col {
    max-width: 768px;
    /*no*/
    position: relative;
}

.grid-card-title {
    display: flex;
    gap: 8px;/*no*/
    margin-bottom: 10px;
    /*no*/
}

.grid-card-title .icon{
    margin-top: 4px;/*no*/
}

.grid-card-title .grid-name {
    word-wrap: anywhere;
    font-size: 24px;
    /*no*/
    font-weight: bold;
    width: calc(100% - 30px);
    /*no*/
    height: 60px;
    /*no*/
    max-height: 60px;
    /*no*/
    line-height: 30px;
    /*no*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    cursor: pointer;
    top: 0;
    color: #333;
}

.grid-card-edit {
    position: absolute;
    top: 0;
    left: 0;
    padding-left: 0;
}

.grid-card-edit >>> .el-textarea__inner {
    padding: 0 4px;
    /*no*/
    font-family: Arial;
    font-size: 24px;
    /*no*/
    font-weight: bold;
    line-height: 26px;
    /*no*/
    letter-spacing: 0em;
    color: #2E2F33;
    overflow: hidden;
}

.grid-card-edit >>> .el-textarea__inner:focus {
    border-color: #D8D8D8;
}

.grid-card {
    height: 338px;
    /*no*/
}

.grid-card >>> .el-switch__core {
    width: 20px !important;
    /*no*/
    height: 14px;
    /*no*/
}

.grid-card >>> .el-switch__core:after {
    width: 10px;
    /*no*/
    height: 10px;
    /*no*/
}

.grid-card >>> .el-switch.is-checked .el-switch__core::after {
    margin-left: -10px;
    /*no*/
}

.grid-schdule {
    height: 20px;
    /*no*/
}

.grid-route {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    /*no*/
}

.grid-route .grid-route-item {
    width: 200px;
    /*no*/
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.grid-route .grid-route-item:hover {
    text-decoration: underline;
    cursor: pointer;
}

.grid-route .grid-route-item .grid-route-name {
    width: 200px;
    /*no*/
    text-align: center;
    font-size: 14px;
    /*no*/
    display: -webkit-box;
    -webkit-line-clamp: 2; /* 限制文本为2行 */
    -webkit-box-orient: vertical;
    overflow: hidden; /* 隐藏溢出的文本 */
}

.grid-route .grid-route-item .task-icon {
    height: 70px;
    /*no*/
}

.grid-route .grid-route-item .task-icon-multi {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    /*no*/
    height: 60px;
    /*no*/
    flex-wrap: wrap;
    position: relative;
}

.grid-route .grid-route-item .task-icon-multi-more {
    position: absolute;
    width: 20px;
    /*no*/
    height: 20px;
    /*no*/
    background-color: #5562B4;
    border-radius: 20px;
    /*no*/
    border: 2px solid rgba(255, 255, 255, 0.6);
    /*no*/
    color: #ffffff;
    font-size: 12px;
    /*no*/
    font-weight: 500;
    line-height: 20px;
    /*no*/
    text-align: center;
}

.grid-function {
    position: absolute;
    width: calc(100% - 70px);
    /*no*/
    bottom: 25px;
    /*no*/
    padding-top: 25px;
    /*no*/
    height: 50px;
    /*no*/
    box-sizing: border-box;
    border-width: 1px 0px 0px 0px;
    /*no*/
    border-style: solid;
    border-color: #D3DCF0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.grid-state {
    float: left;
}

.grid-btns {
    float: right;
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: hidden;
}

.grid-card:hover .grid-btns {
    visibility: unset;
}

.status-txt {
    display: flex;
    align-items: center;
    justify-content: left;
}

.status-txt-text {
    justify-content: left;
}

.status-txt-text:hover {
    text-decoration: underline;
    cursor: pointer;
}

.status-txt .operation-result {
    margin-left: 5px;
    /*no*/
    font-family: Arial;
    font-size: 14px;
    /*no*/
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
}

.status-txt:has(.task-failure) {
    color: #F54958;
}

.status-txt:has(.task-patial) {
    color: #6F6F6F;
}

.status-txt:has(.task-success) {
    color: #30A734;
}

.el-checkbox {
    display: none;
}

.batchDel .el-checkbox {
    display: inline-block;
    position: absolute;
    right: 0px;
    /*no*/
    top: 0px;
    /*no*/
    width: 100%;
    height: 100%;
    z-index: 2;
}

.batchDel .grid-card:has(.el-checkbox.is-checked) {
  /* box-sizing: border-box; */
    border: 1px solid #4181FF;
    /*no*/
}
  
.el-checkbox >>> .el-checkbox__input{
    position: absolute;
    right: 10px;
    /*no*/
    top: 10px;
    /*no*/
}

.el-checkbox >>> .el-checkbox__inner {
    width: 24px;
    /*no*/
    height: 24px;
    /*no*/
}

.el-checkbox >>> .el-checkbox__inner::after {
    top: 2.5px !important;
    /*no*/
    left: 8px !important;
    /*no*/
}

.speed-up-btn {
    height: 16px;
    /*no*/
    border-radius: 4px;
    /*no*/
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 6px 12px;
    /*no*/
    gap: 6px;
    /*no*/
    background: linear-gradient(172deg, #FFA133 6%, #F58427 74%);
    font-size: 12px;
    /*no*/
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0em;
    color: #ffffff;
    margin-left: 10px;
    /*no*/
    cursor: pointer;
}

</style>


// WEBPACK FOOTER //
// src/components/common/tabs/tabs_task_list/tabs_single_task_card.vue